import { CHANGE_LOGIN_VALUE } from '../actions/actionTypes';

const initialState = {
    isLogged: false
}

export const userStatus = (state = initialState, action) => {
    switch(action.type) {
        case CHANGE_LOGIN_VALUE:
            console.log("log inside reducer");
            console.log(action.isLogged);
            return {
                ...state,
                isLogged: action.isLogged
            };
        default:
            return state;
    }
}